let height;
export function sendPostMessage() {
  console.log('Sending message');
  //   if (height !== document.getElementById('container').offsetHeight) {
  height = document.getElementById('container').offsetHeight;
  window.parent.postMessage(
    {
      frameHeight: height + 150,
    },
    '*',
  );
  console.log(height); // check the message is being sent correctly
  //   }
}
